var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.33 382.67C69.33 244 181.33 132 320 132C458.67 132 570.67 244 570.67 382.67C570.67 521.33 458.67 633.33 320 633.33C181.33 633.33 69.33 521.33 69.33 382.67ZM96 382.67C96 506.67 196 606.67 320 606.67C444 606.67 544 506.67 544 382.67C544 260 444 158.67 320 158.67C196 158.67 96 258.67 96 382.67Z",
    id: "p1f9QpdqNY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 382.67C132 278.67 216 194.67 320 194.67C424 194.67 508 278.67 508 382.67C508 486.67 424 570.67 320 570.67C216 570.67 132 486.67 132 382.67ZM158.67 382.67C158.67 472 230.67 544 320 544C409.33 544 481.33 472 481.33 382.67C481.33 293.33 409.33 221.33 320 221.33C230.67 221.33 158.67 293.33 158.67 382.67Z",
    id: "c1W38J6DDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.67 158.67C286.67 158.67 281.33 153.33 281.33 145.33C281.33 141.6 281.33 122.93 281.33 89.33C259.73 89.33 247.73 89.33 245.33 89.33C237.33 89.33 232 84 232 76C232 70.4 232 25.6 232 20C232 12 237.33 6.67 245.33 6.67C260.27 6.67 379.73 6.67 394.67 6.67C402.67 6.67 408 12 408 20C408 25.6 408 70.4 408 76C408 84 402.67 89.33 394.67 89.33C392.27 89.33 380.27 89.33 358.67 89.33C358.67 123.73 358.67 142.84 358.67 146.67C358.67 153.33 353.33 158.67 345.33 158.67C335.2 158.67 299.73 158.67 294.67 158.67ZM332 132C332 98.4 332 79.73 332 76C332 68 337.33 62.67 345.33 62.67C347.73 62.67 359.73 62.67 381.33 62.67L381.33 33.33L258.67 33.33L258.67 62.67C280.27 62.67 292.27 62.67 294.67 62.67C302.67 62.67 308 68 308 76C308 79.73 308 98.4 308 132L332 132Z",
    id: "bZ3nAml6P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 220C471.6 216.27 436.4 186.4 432 182.67C426.67 177.33 425.33 169.33 430.67 164C436.93 156.67 487.07 98 493.33 90.67C496 88 498.67 86.67 502.67 85.33C506.67 85.33 509.33 86.67 512 88C516.4 91.73 551.6 121.6 556 125.33C561.33 130.67 562.67 138.67 557.33 144C551.07 151.33 500.93 210 494.67 217.33C492 221.33 489.33 222.67 484 222.67C485.33 222.67 484 222.67 484 222.67C481.33 222.67 477.33 221.33 476 220ZM482.67 190.67L528 137.33L505.33 117.33L460 170.67L482.67 190.67Z",
    id: "b1qa4dVyL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67 382.67C306.67 373.2 306.67 297.47 306.67 288C306.67 280 312 274.67 320 274.67C328 274.67 333.33 280 333.33 288C333.33 297.47 333.33 373.2 333.33 382.67C333.33 390.67 328 396 320 396C312 396 306.67 390.67 306.67 382.67Z",
    id: "b3a9U3wZJO"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p1f9QpdqNY",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p1f9QpdqNY",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1W38J6DDE",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1W38J6DDE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bZ3nAml6P",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bZ3nAml6P",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1qa4dVyL",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1qa4dVyL",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3a9U3wZJO",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b3a9U3wZJO",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon1);
export default __webpack_public_path__ + "static/media/info-icon-1.286c7356dea5b1be3e61f9b21b8036ab.svg";
export { ForwardRef as ReactComponent };